import { render, staticRenderFns } from "./ApprovalReference.vue?vue&type=template&id=6a34a326&scoped=true&"
import script from "./ApprovalReference.vue?vue&type=script&lang=js&"
export * from "./ApprovalReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a34a326",
  null
  
)

export default component.exports